import { render, staticRenderFns } from "./PropertyList.vue?vue&type=template&id=1ddc6d06&scoped=true&"
import script from "./PropertyList.vue?vue&type=script&lang=js&"
export * from "./PropertyList.vue?vue&type=script&lang=js&"
import style0 from "./PropertyList.vue?vue&type=style&index=0&id=1ddc6d06&lang=scss&scoped=true&"
import style1 from "./PropertyList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddc6d06",
  null
  
)

export default component.exports